// GET_LIMITED_ANNOUNCEMENT
export const GET_LIMITED_ANNOUNCEMENT_REQUEST =
  "GET_LIMITED_ANNOUNCEMENT_REQUEST";
export const GET_LIMITED_ANNOUNCEMENT_SUCCESS =
  "GET_LIMITED_ANNOUNCEMENT_SUCCESS";
export const GET_LIMITED_ANNOUNCEMENT_FAIL = "GET_LIMITED_ANNOUNCEMENT_FAIL";
